import React from "react";
import { LanguageSelectorComponent } from "./language-selector/LanguageSelectorComponent";
import { NewsMenuComponent } from "./news-menu/NewsMenuComponent";
import { EnvironmentSelectorComponent } from "./environment-selector/EnvironmentSelectorComponent";
import { HelpMenuComponent } from "./help-menu/HelpMenuComponent";

type IHeaderComponentProps = {}

export class HeaderComponent extends React.Component<IHeaderComponentProps> {
    render() {
        return (
            <header>
                <h1>
                    <a href="/POW3/Explore">PACSonWEB</a>
                </h1>
                <div id="header-components">
                    <NewsMenuComponent />
                    <LanguageSelectorComponent />
                    <EnvironmentSelectorComponent />
                    <HelpMenuComponent />
                </div>
            </header>
        );
    }
}
